var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 117.4 45.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 58.7,
    y1: 2.6,
    x2: 58.7,
    y2: 62.9,
    gradientTransform: "translate(0 48) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a0094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8800a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ac00ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ca00cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e100d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f200e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fb00e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.2,38.4h-2.9V1.5c0-.4,0-.8.3-1.2.3-.2.8-.3,1.2-.3h2.9v35.2h6.7c1.1,0,1.8-.2,2.1-.7.3-.8.5-1.6.4-2.4v-15.3c0-.8,0-1.7-.4-2.4-.3-.5-1-.7-2.1-.7h-4.5v-1.7c0-.4,0-.8.2-1.2.2-.2.5-.3,1.1-.3h4.9c1.9,0,3.2.4,4,1.2s1.2,2.1,1.2,4v17.5c0,1.9-.4,3.2-1.2,4s-2.1,1.2-4,1.2h-10,0ZM91.4,7.3c.2-.3.3-.8.3-1.2v-2.9h-3.3c-.4,0-.8,0-1.2.3-.2.3-.3.8-.3,1.2v2.9h3.3c.4,0,.8,0,1.2-.3ZM87.4,10.8c-.2.3-.4.8-.3,1.2v26.4h2.9c.4,0,.8,0,1.2-.3.2-.3.3-.8.3-1.2V10.5h-2.9c-.4,0-.8,0-1.1.3ZM106.4,10.5h-6c-1.9,0-3.2.4-4,1.2s-1.2,2.1-1.2,4v17.5c0,1.9.4,3.2,1.2,4s2.1,1.2,4,1.2h8.3c.6,0,1,0,1.1-.3.2-.4.3-.8.2-1.2v-1.7h-7.9c-1.1,0-1.8-.2-2.1-.7-.3-.8-.5-1.6-.4-2.4v-15.3c0-.9,0-1.7.5-2.5.3-.4,1.1-.6,2.3-.6h2.4c.8-.1,1.6.1,2.2.6.4.7.6,1.5.6,2.3v4.2c0,.8,0,1.7-.4,2.4-.3.5-1,.7-2.1.7h-3.2v1.7c0,.4,0,.8.2,1.2.2.2.5.3,1.1.3h3.3c1.9,0,3.2-.4,4-1.2s1.2-2.1,1.2-4v-6.2c0-1.9-.4-3.2-1.2-4s-2.1-1.2-4-1.2h0ZM117,40.9c-.3-.2-.8-.4-1.2-.3h-2.9v3.3c-.2.6.2,1.3.8,1.5.2,0,.5,0,.7,0h2.9v-3.3c0-.4,0-.8-.3-1.2h0ZM109.7,41.1c-.3-.2-.8-.3-1.2-.3H18.8l-4.9-16.2c1.2,0,2.4-.5,3.2-1.4.7-1.1,1-2.4.9-3.8v-9.6c0-1.9-.4-3.2-1.2-4s-2.1-1.2-4-1.2H1.5c-.4,0-.8,0-1.2.3-.2.3-.3.8-.3,1.2v36.9h2.9c.4,0,.8,0,1.2-.3.2-.3.3-.8.3-1.2V7.8h6.7c1.1,0,1.8.2,2.1.7.3.8.5,1.6.4,2.4v7.5c0,.8,0,1.7-.4,2.4-.3.5-1,.7-2.1.7h-4.5v1.7c0,.4,0,.8.2,1.2.2.2.5.3,1.1.3h1.7l5.8,19c0,.5.3.9.7,1.2.4.2.8.3,1.3.3h92.7v-2.9c0-.4,0-.8-.3-1.1h0ZM22.7,37.2c-.8-.8-1.2-2.1-1.2-4V15.7c0-1.9.4-3.2,1.2-4s2.1-1.2,4-1.2h7.7c1.9,0,3.2.4,4,1.2s1.2,2.1,1.2,4v17.4c0,1.9-.4,3.2-1.2,4s-2.1,1.2-4,1.2h-7.6c-1.9,0-3.2-.4-4-1.2h0ZM25.9,32.1c0,.8,0,1.7.4,2.4.3.5,1,.7,2.1.7h4.2c1.1,0,1.8-.2,2.1-.7.3-.8.5-1.6.4-2.4v-15.2c0-.8,0-1.7-.4-2.4-.3-.5-1-.7-2.1-.7h-4.1c-1.1,0-1.8.2-2.1.7-.4.8-.5,1.6-.4,2.4v15.2ZM46.4,38.4h9.9c1.9,0,3.2-.4,4-1.2s1.2-2.1,1.2-4V15.7c0-1.9-.4-3.2-1.2-4s-2.1-1.2-4-1.2h-4.9c-.6,0-1,.1-1.1.3-.2.3-.3.7-.3,1.1v1.7h4.5c1.1,0,1.8.2,2.1.7.3.8.5,1.6.4,2.4v15.3c0,.8,0,1.7-.4,2.4-.3.5-1,.7-2.1.7h-6.7V0h-2.9c-.4,0-.8,0-1.2.3-.2.3-.3.8-.3,1.2v36.9h3,0Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurple);
export default __webpack_public_path__ + "static/media/LogoPurple.23355a42752380e3bfed44c11a96a315.svg";
export { ForwardRef as ReactComponent };